import { gql } from '@apollo/client';

export const ZIP_CODE_FIND_ONE_QUERY = gql`
  query ZipCodesFindOne($filters: [FilterParam!]) {
    zipCodesFindOne(filters: $filters) {
      code
      city
      state
      latitude
      longitude
    }
  }
`;
